/**
 * Browser entry point.
 *
 * The provider order is load-bearing:
 *
 * 1. `ThemeProvider` - outermost, because it writes a class to `<html>` and
 *    nothing else depends on it. Putting it deeper would work, and would mean the
 *    theme effect ran after every other provider's effects for no reason.
 * 2. `AuthProvider` - owns the API client, which `WorkspaceShell` passes down.
 * 3. `ToastProvider` - notices are rendered at the application root so that a
 *    board-level failure is still visible when the board has failed to render.
 *
 * `StrictMode` is on. Its double-invoked effects are the point: they are how a
 * missing cleanup in the socket lifecycle would show up as two sockets during
 * development rather than as a duplicated presence entry in production. The
 * `BoardSocket` class and the `useEffect` that owns it are written to survive
 * being mounted, unmounted and mounted again.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App } from './components/App.js';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('The #root element is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
